// Module
var code = `<code> </code>`;
// Exports
export default code;